import iconInstagram from '../../../assets/iconInstagram.svg'
import logoMoovery from '../../../assets/logoMoovery2.svg'
import iconYoutube from '../../../assets/iconYoutube.svg'
import iconSeta from '../../../assets/setaFooter.svg'

import TextFooter from '../../atoms/TextFooter'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { Link } from 'react-router-dom'

import * as Styled from './styles'

export default function Footer() {
  function openInstagramMoovery() {
    window.open('https://www.instagram.com/moovery.app/')
  }
  function openYoutubeMoovery() {
    window.open('https://www.youtube.com/@mooveryapp')
  }

  let location = useLocation()

  useEffect(() => {
    const scriptId = 'ra-embed-verified-seal'
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
      return
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = scriptId
    script.src = 'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js'
    script.setAttribute(
      'data-id',
      'aW9Gb2xtUmFwZWJxd2lPODptb292ZXJ5LXNlcnZpY29zLWRlLWludGVybWVkaWFjYW8tZGUtbmVnb2Npb3M='
    )
    script.setAttribute('data-target', 'ra-verified-seal')
    script.setAttribute('data-model', 'horizontal_1')

    document.body.appendChild(script)
  }, [])

  return (
    <Styled.Content>
      <div className="container">
        <Styled.Header>
          <Styled.Infos>
            <img src={logoMoovery} alt="logoMoovery" />
            <Styled.Hr />
            <TextFooter>WhatsApp: +55 (11) 93621-7647</TextFooter>
            <TextFooter>contato@moovery.app</TextFooter>
          </Styled.Infos>
          <Styled.RightColumn>
            <Styled.SocialGroup>
              <img
                src={iconInstagram}
                alt=""
                onClick={openInstagramMoovery}
                style={{ cursor: 'pointer' }}
              />
              <img
                src={iconYoutube}
                alt=""
                onClick={openYoutubeMoovery}
                style={{ cursor: 'pointer' }}
              />
            </Styled.SocialGroup>
            <Styled.ButtonGroup>
              <Link to="/motoboy" style={{ textDecoration: 'none' }}>
                <Styled.Button>
                  Aplicativo para entregadores
                  <img src={iconSeta} alt="" />
                </Styled.Button>
              </Link>
              <Link to="/empresas" style={{ textDecoration: 'none', marginBottom: '1.5rem' }}>
                <Styled.Button>
                  Cadastrar empresa
                  <img src={iconSeta} alt="" />
                </Styled.Button>
              </Link>
              <Link to="/politica" style={{ textDecoration: 'none' }}>
                <TextFooter>
                  <strong>Política de privacidade</strong>
                </TextFooter>
              </Link>
              {location.pathname === '/motoboy' && (
                <Link to="/termos-entregador" style={{ textDecoration: 'none' }}>
                  <TextFooter>
                    <strong>Termos de uso entregador</strong>
                  </TextFooter>
                </Link>
              )}
              {location.pathname === '/empresas' && (
                <Link to="/termos-empresa" style={{ textDecoration: 'none' }}>
                  <TextFooter>
                    <strong>Termos de uso empresa</strong>
                  </TextFooter>
                </Link>
              )}
            </Styled.ButtonGroup>
            <Styled.SealWrapper>
              <div id="ra-verified-seal" />
            </Styled.SealWrapper>
          </Styled.RightColumn>
        </Styled.Header>
      </div>
    </Styled.Content>
  )
}
